exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".v-btn--bottom[data-v-6a63bfd0]:not(.v-btn--absolute){bottom:35px}", "", {"version":3,"sources":["/vue-ui/src/views/Todo.vue"],"names":[],"mappings":"AACA,sDACE,WAAa,CACd","file":"Todo.vue","sourcesContent":["\n.v-btn--bottom[data-v-6a63bfd0]:not(.v-btn--absolute) {\n  bottom: 35px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a63bfd0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Todo.vue
// module id = 108
// module chunks = 3